<template>
  <div id="BMIChartPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="نمودار BMI"></ActionBar>
    <div class="row container mx-auto no-gutters p-0 mt-10">
      <div class="col-12 col-md-8 mx-auto">
    <ChartBmi v-if="isChartLoaded" :chart-label="chartLabel" :over-weight-data="overWeightData"
              :student-bmi-data="studentBmiData" :under-weight-data="underWeightData" :obese-data="obeseData" :normal-weight-data="normalWeightData"/>
    </div>
    </div>
    <FooterMenu/>
  </div>

</template>

<script>
let _this = null
import ActionBar from "../../components/ActionBar";
import FooterMenu from "../../components/FooterMenu";
import ChartBmi from "../../components/ChartBmi";

export default {
  name: "BMIChart",
  metaInfo: {
    title: 'مسیربرتر-نمودار BMI'
  },
  components: {ChartBmi, FooterMenu, ActionBar},
  data: () => ({
    chartLabel: [],
    studentBmiData: [],
    underWeightData: [],
    overWeightData: [],
    obeseData: [],
    normalWeightData: [],
    isChartLoaded: false,

  }),
  mounted() {
    _this = this
    this.getData()
  },
  methods: {
    getData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();

      let current = new Date()
      let lastYear = current.setDate(current.getDate() - 365)
      let startDate = new Date(lastYear)
      urlencoded.append("StartDate", this.$convertDate(startDate.toISOString()));
      let now = new Date()
      urlencoded.append("EndDate", this.$convertDate(now.toISOString()));
      urlencoded.append("StudentProfileID", this.$getUserData().studentID);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportManagement/_Bmi", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let label = []
            let data = []
            let underWeight = []
            let overWeight = []
            let obese =[]
            let normal=[]
            for (let i = 0; i < json.length; i++) {
              label.push(_this.$convertDate(json[i].ModifiedDate))
              data.push(_this.$roundNum(json[i].RealBmi))
              underWeight.push(18.5)
              normal.push(25)
              overWeight.push(29.9)
              obese.push(70)

            }
            _this.chartLabel = label
            _this.studentBmiData = data
            _this.underWeightData = underWeight
            _this.overWeightData = overWeight
            _this.obeseData = obese
            _this.normalWeightData = normal
            _this.isChartLoaded = true
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>